<template>
	<div class="alert-item">
		<el-card class="box-cardPw" style="width: 400px">
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
					 class="demo-ruleForm" size="mini">
				<el-form-item label="请输入旧密码" prop="oldpass">
					<el-input type="password" v-model="ruleForm.oldpass" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="请输入新密码" prop="pass">
					<el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="新确认密码" prop="checkPass">
					<el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
					<el-button @click="resetForm('ruleForm')">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	export default {
	    name: "SysPw",
		data() {
		    var validatePass = (rule, value, callback) => {
		        if (value === '') {
		            callback(new Error('请输入密码'));
		        } else {
		            if (this.ruleForm.checkPass !== '') {
		                this.$refs.ruleForm.validateField('checkPass');
		            }
		            callback();
		        }
		    };
		    var validatePass2 = (rule, value, callback) => {
		        if (value === '') {
		            callback(new Error('请再次输入密码'));
		        } else if (value !== this.ruleForm.pass) {
		            callback(new Error('两次输入密码不一致!'));
		        } else {
		            callback();
		        }
		    };
		    return {
		        ruleForm: {
		            oldpass: '',
		            pass: '',
		            checkPass: ''
		        },
		        rules: {
		            oldpass: [
		                {validator: validatePass, trigger: 'blur'}
		            ],
		            pass: [
		                {validator: validatePass, trigger: 'blur'}
		            ],
		            checkPass: [
		                {validator: validatePass2, trigger: 'blur'}
		            ]
		        },
		        hr: null,
		        hr2: null,
		        dialogVisible: false,
		        passwdDialogVisible: false
		    }
		},
		methods:{
			submitForm(formName) {
			    this.$refs[formName].validate((valid) => {
			        if (valid) {
						debugger
			            this.ruleForm.userid =JSON.parse(window.sessionStorage.getItem("user")).id,
			            this.putRequest("/system/config/pass", this.ruleForm).then(resp => {
			                if (resp) {
			                    this.getRequest("/logout");
			                    window.sessionStorage.removeItem("user");
								sessionStorage.path=null;
			                    this.$store.commit('initRoutes', []);
			                    this.$router.replace("/");
			                }
			            })
			        } else {
			            return false;
			        }
			    });
			},
			resetForm(formName) {
			    this.$refs[formName].resetFields();
			},
		}
	}
</script>

<style>
	.box-cardPw{
		
		background: #FFFFFF;
	}
</style>
